/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-29",
    versionChannel: "nightly",
    buildDate: "2025-05-29T00:06:59.114Z",
    commitHash: "9fae1bf1a1d86eaea377fedb7296ea6625d00ef5",
};
